import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonOlList from '../../../common-components/common-ol-list';

const devRecList = {
    colorNumber: '#3A74B7',
    big: true,
    bignormal: true,
    list: [
        'Лендинг на&nbsp;корпоративном портале для сервиса &laquo;Одно окно&raquo; с&nbsp;динамическим обновлением ' +
            'данных о&nbsp;зарегистрированных компаниях, экспортеров и&nbsp;учетных записей, которые получаем с&nbsp;сервиса.',
        'Онлайн-форма контроля испытательного срока. Данная форма позволяет удобно и&nbsp;в&nbsp;полуавтоматическом ' +
            'режиме ставить задачи и&nbsp;контролировать&nbsp;их. Предусмотрен функционал рассылки напоминаний о&nbsp;смене ' +
            'статуса задач ответственному лицу.',
        'Раздел HR&nbsp;и&nbsp;функционал различных заявок. Он&nbsp;позволяет автоматизировать часть рутинной работы: ' +
            'создание и&nbsp;обработка заявок на&nbsp;авто, отпуск, согласование отгула и&nbsp;прочее. Данная автоматизация ' +
            'позволила освободить у&nbsp;HR до&nbsp;20% его рабочего времени.',
    ],
};

const Portal = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="dev-rec-portal" bigPaddings={true}>
                <div className="dev-rec-portal__wrapper">
                    <div className="dev-rec-portal__grid">
                        <div className="dev-rec-portal__content">
                            <CommonSmallTitle className="dev-rec-portal__title">
                                Внутренний портал
                            </CommonSmallTitle>
                            <CommonOlList
                                className="dev-rec-portal__list"
                                CommonOlList={devRecList}
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Portal;
